import { Component, Input } from '@angular/core';
import { AbstractNgModelComponent } from '../../base/abstract-ng-model/abstract-ng-model.component';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { UserApiService } from 'src/app/services/api/user-api.service';
import { NzImage, NzImageService } from 'ng-zorro-antd/image';

@Component({
  selector: 'app-image-uploader-qiniu',
  templateUrl: './image-uploader-qiniu.component.html',
  styleUrls: ['./image-uploader-qiniu.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: ImageUploaderQiniuComponent,
    },
  ],
})
export class ImageUploaderQiniuComponent extends AbstractNgModelComponent {
  @Input() width = '200px';
  @Input() height = '200px';
  @Input() cover = false;
  @Input() ratio = 1;
  loading = false;
  value: string[] = [];

  constructor(private api: UserApiService, private image: NzImageService) {
    super();
  }

  clear(img: any) {
    const index = this.value.indexOf(img);
    if (index !== -1) {
      this.value.splice(index, 1);
      this.onChange();
    }
  }

  onFileChange(e: any) {
    const files = e.target.files;
    if (files.length === 0) {
      return;
    }
    const file = files[0];
    this.uploadFile(file);
  }

  async uploadFile(file: any) {
    try {
      this.loading = true;
      const r = await this.api.postQiniu(file);
      this.value.push(r.url);
      this.onChange();
    } catch (error) {
    } finally {
      this.loading = false;
    }
  }

  preview(img: any) {
    if (!img) {
      return;
    }
    const image: NzImage = {
      src: img,
    };
    this.image.preview([image]);
  }
}
